import { render, staticRenderFns } from "./FileSelector.yaml?vue&type=template&id=6af74d3c&component"
import script from "./FileSelector.yaml?vue&type=script&lang=ts&component"
export * from "./FileSelector.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports